/**
 * This code was  originally copied from the lexical playground source code on github
 * And so it doesn't follow our code style
 * https://github.com/facebook/lexical/tree/main/packages/lexical-playground
 *
 */

import "./ContentEditable.css";

import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import ScrollShadowWrapper from "components/shared/ScrollShadowWrapper";

export default function LexicalContentEditable({ className }: { className?: string }): JSX.Element {
    return (
        <ScrollShadowWrapper className="CommentPlugin_CommentInputBox_Scroller">
            <ContentEditable className={className || "ContentEditable__root"} />
        </ScrollShadowWrapper>
    );
}
